import ImageCTimur from "../../assets/img/ourTeam/picturePNG/timur_c.png";
import ImageCAnd from "../../assets/img/ourTeam/picturePNG/andrey_c.png";
import ImageCBog from "../../assets/img/ourTeam/picturePNG/bohdan_c.png";
import ImageCNat from "../../assets/img/ourTeam/picturePNG/natalia_c.png";
import ImageCNaz from "../../assets/img/ourTeam/picturePNG/nazar_c.png";
import ImageCSer from "../../assets/img/ourTeam/picturePNG/serhii_c.png";
import ImageCRomP from "../../assets/img/ourTeam/picturePNG/roma_c.png";
import ImageCDm from "../../assets/img/ourTeam/picturePNG/dima_c.png";

export const sliderDataDE = [
  {
    id: "1",
    name: "Roman Stepaniuk",
    description: "Entwickler für Benutzeroberflächen",
    img: ImageCTimur,
  },
  {
    id: "2",
    name: "Andrey Alaverdian",
    description: "Entwickler für Benutzeroberflächen",
    img: ImageCAnd,
  },
  {
    id: "3",
    name: "Bohdan Kovalenko",
    description: "Back-End-Entwickler",
    img: ImageCBog,
  },
  {
    id: "4",
    name: "Natalia Larina",
    description: "Vermarkterin",
    img: ImageCNat,
  },
  {
    id: "5",
    name: "Sakhanda Nazar",
    description: "Entwickler für Benutzeroberflächen",
    img: ImageCNaz,
  },
  {
    id: "6",
    name: "Serhii Lusgar ",
    description: "Webdesigner",
    img: ImageCSer,
  },
  {
    id: "7",
    name: "Roman Platonov ",
    description: "Videobearbeiter",
    img: ImageCRomP,
  },
  {
    id: "8",
    name: "Dmytro Shevchenko ",
    description: "Webdesigner, Teamleiter",
    img: ImageCDm,
  },
];
